"use strict";
// @ts-ignore
try {
    self['workbox:recipes:7.2.0'] && _();
}
catch (e) { }
